import styled from 'styled-components';

export const StyledArrowContainer = styled.div<{ bottomPosition: number }>`
    position: absolute;
    bottom: ${({ bottomPosition }) => `${bottomPosition}px`};
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;

    & span {
        margin-right: 10px;
    }
`;

export const StyledArrow = styled.div`
    position: relative;
    width: 10px;
    height: 10px;
    transform: rotate(-45deg);

    span {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border: none;
        border-bottom: 1px solid #ff77fc;
        border-right: 1px solid #ff77fc;
        animation: animate 1.5s linear infinite;
        &:nth-child(1) {
            top: -10px;
            left: -10px;
            animation-delay: 0s;
        }
        &:nth-child(2) {
            top: -5px;
            left: -5px;
            animation-delay: 0.2s;
        }
        &:nth-child(3) {
            top: 0;
            left: 0;
            animation-delay: 0.4s;
        }
        &:nth-child(4) {
            top: 5px;
            left: 5px;
            animation-delay: 0.6s;
        }
    }

    @keyframes animate {
        0% {
            border-color: #7e71ff;
            transform: translate(0, 0);
        }
        20% {
            border-color: #743ad5;
            transform: translate(15px, 15px);
        }
        20.1%,
        100% {
            border-color: #ff77fc;
        }
    }
`;
